module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/WizardButton/images/border-bonus-hover.2c2ba265.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/WizardButton/images/border-bonus-hover.png
// module id = 2535
// module chunks = 11